<template>
  <div>
    <!-- :style='opacityStyle' -->
    <div
      class="scroller_wrapper"
      v-if="screenWidth"
      :style="{ width: screenWidth }"
      id="boxFixed"
      v-show="isStatus"
    >
      <div class="scroller_content">
        <div class="scroller_left">
          <img src="@/assets/img/dialog/bottom_inform.jpg" alt="" />
        </div>
        <div class="scroller_right">
          <div class="top_shade" v-show="informData.length >= 3"></div>
          <div id="box">
            <div
              id="con1"
              ref="con1"
              :class="[
                { anim: animate == true },
                { 'actave-ul': informData.length < 4 },
              ]"
              @mouseenter="mEnter"
              @mouseleave="mLeave"
            >
              <li
                class="scroller_li"
                v-for="item in informData"
                :key="item.indx"
                @click="handleInform(item)"
              >
                <div class="index_li">{{ item.indx }}</div>
                <img
                  v-show="item.newFlag"
                  src="@/assets/img/dialog/icon-notice-active.svg"
                  alt=""
                />
                <img
                  v-show="!item.newFlag"
                  src="@/assets/img/dialog/icon-notice.svg"
                  alt=""
                />
                <div
                  class="scroller_p"
                  :class="item.newFlag ? 'is_show' : 'is_hidden'"
                >
                  {{ item.title }}
                </div>
                <div class="scroller_new" v-show="!item.newFlag">NEW</div>
              </li>
            </div>
          </div>
          <div class="isInformShow" @click="handleClose"></div>
        </div>
      </div>
    </div>
    <el-dialog
      :modal-append-to-body="false"
      :width="width"
      top="10vh"
      title="公告通知"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="resetPopupData"
    >
      <div class="itemContent" :style="height" v-html="itemContent"></div>
      <div class="button">
        <div class="submit-btn" size="small" @click="resetPopupData">关闭</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../modules/projectA/api/nesting";
// import { contentText } from '@/assets/js/bottomScroller.js';
export default {
  data () {
    return {
      show: false,
      offsetTop: 0,
      isStatus: false,
      informData: [],
      visible: false,
      itemContent: '',
      currentId: 0,
      screenWidth: '',
      animate: false,
      width:'600px',
      height:{
        height:'300px'
      },
    }
  },
  created () {
    this.getDAnnouncementList({ multiCharacter: 1111 });
  },
  mounted () {
    let that = this;
    window.screenWidth = (document.body.clientWidth - 190) + 'px'
    that.screenWidth = window.screenWidth;
    window.onresize = () => {
      window.screenWidth = (document.body.clientWidth - 190) + 'px'
      that.screenWidth = window.screenWidth;
    }
  },

  methods: {
    scroll () {
      const con1 = this.$refs.con1
      this.$refs.con1.style.marginTop = '-27px'
      this.animate = !this.animate
      //   在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(() => {
        this.informData.push(this.informData[0])
        this.informData.shift();
        con1.style.marginTop = '0px'
        this.animate = !this.animate
        //   这个地方如果不把animate取反会出现消息回滚的现象，此时把ul元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      }, 500)
    },
    mEnter () {
      clearInterval(this.timer1)
    },
    mLeave () {
      if (!this.visible && this.informData.length > 3) {
        this.timer1 = setInterval(this.scroll, 1000)
      }
    },

    handleInform (item) {
      // if(item.title.indexOf('关于配合国家发改委党校开展政府') != -1){
      //   this.width = "1100px"
      //   this.itemContent = item.content.replace(/\\n/g, "</br>");
      //   this.height.height = '380px'
      //   item.newFlag = true;
      //   this.visible = true;
      //   this.informData.forEach((i,index)=>{
      //     if(i.announcementid == item.announcementid){
      //       this.informData.splice(index,1);
      //     }
      //   })
      // }else{
        api.cancelContext({ announcementId: item.announcementid + '' }).then(res => {
          if (res.code == "200" && res.data == true) {
            item.newFlag = true;
            this.itemContent = item.content.replace(/\\n/g, "</br>");
            this.visible = true;
          }
        })
      // }
    },
    handleClose () {
      this.isStatus = false;
      sessionStorage.getItem('isShow_message', 'hidden_message')
    },
    resetPopupData () {
      if(this.width == "600px"){
        this.getDAnnouncementList({ multiCharacter: 1111 });
      }
      if(!this.informData.length){
        this.isStatus = false;
        sessionStorage.getItem('isShow_message', 'hidden_message')
      }
      this.visible = false;
    },
    getDAnnouncementList (id) {
      api.getDAnnouncementList(id).then(res => {
         if(this.$store.state.USERINFO.memberIdentity == "double_identity" || this.$store.state.USERINFO.memberIdentity == "supplier"){
          this.memberIdentity = true;
        }else{
          this.memberIdentity = false;
        }
        if (res.code == 200) {
          res.data.length && res.data.forEach((item, index) => {
            item.indx = index + 1;
          });
          this.informData = res.data;
          // this.informData.forEach(item=>{
          //   if(item.title.indexOf('关于配合国家发改委党校开展政府') !=-1){
          //     item.content = contentText
          //   }
          // })
          if (!sessionStorage.getItem('isShow_message') && res.data.length) {
            this.isStatus = true;
             if (this.informData.length > 3) {
            this.timer1 = setInterval(this.scroll, 1000)
          }
            // 第一次登录供应商默认打开 title: 关于配合国家发改委党校开展政府稳市场... 
          // this.informData.forEach(item=>{
          //   if(item.title.indexOf('关于配合国家发改委党校开展政府') !=-1 && this.memberIdentity && !sessionStorage.getItem('defaultAnnouncement')){
          //     this.handleInform(item)
          //     sessionStorage.setItem('defaultAnnouncement','关于配合国家发改委党校开展政府')
          //   }
          // })
          } else {
            this.isStatus = false;
          }
          this.informData = res.data;
        }else{
          this.isStatus = false;
        }

      });
    },

  },

  destroyed () {
    clearInterval(this.timer1);
  },


}
</script>

<style lang='scss' scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.scroller_wrapper {
  display: block;
  position: fixed;
  bottom: 0;
  // left: 0;
  // right: 0;
  z-index: 999;
  height: 81px;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
}

.scroller_content {
  width: 1200px;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  height: 81px;
  .scroller_left {
    height: 100%;
    width: 220px;
    margin-right: 36px;
    img {
      width: 100%;
      height: 100%;
      display: flex;
    }
  }

  .scroller_right {
    height: 100%;
    width: 915px;
    // background: palegoldenrod;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background-image: url("../../assets/img/dialog/bottom_right_background.png");
    background-position: right;
    background-repeat: no-repeat;
    background-size: 270px 100%;
    position: relative;
    .top_shade {
      width: 776px;
      height: 20px;
      background: linear-gradient(rgb(255, 255, 255), rgba(255, 255, 255, 0));
      position: absolute;
      z-index: 1002;
      top: 0;
      left: 0;
    }
    .isInformShow {
      width: 12px;
      height: 12px;
      background-image: url("../../assets/img/dialog/inform_close.png");
      background-size: cover;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
    .actave-ul {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

    .scroller_li {
      width: 100%;
      height: 27px;
      display: flex;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      z-index: 1001;
      .index_li {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #ffd67b;
        color: #e36d00;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 13px;
      }
      .scroller_new {
        width: 30px;
        height: 12px;
        border-radius: 3px;
        font-size: 10px;
        color: #fff;
        background: #f0250f;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .scroller_p {
        margin-right: 10px;
        width: 684px;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img {
        width: 12px;
        height: 12px;
        display: block;
        margin-right: 10px;
      }
      .is_hidden {
        color: #333;
      }
      .is_show {
        color: #126ee0;
      }
    }
  }
}
.button {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .submit-btn {
    width: 81px;
    height: 30px;
    line-height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2587ff;
    color: #ffffff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
.itemContent {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: auto;
}
::v-deep .el-dialog__body {
  font-size: 14px;
  color: #333;
  text-align: justify;
  padding: 20px 0;
}
::v-deep.el-dialog__header {
  padding: 0;
  background: #ececec;
  width: 100%;
  height: 40px;

  display: flex;
  align-items: center;
}
::v-deep .el-dialog__title {
  font-size: 14px;
  color: #333;
  margin-left: 20px;
}
::v-deep .el-dialog__headerbtn {
  top: 9px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
#box {
  width: 100%;
  height: 100%;
  line-height: 20px;
  overflow: hidden;
  transition: all 0.5s;
}
.anim {
  transition: all 0.5s;
}
#con1 {
  width: 776px;
  height: 100%;
}
</style>
